export default __webpack_public_path__ + "static/media/iconMapPinBlack.82b4819c.svg";